import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    hexColor: string;
    name: string;
    walkingTime?: string;
}

export const MetroStation: FC<IProps> = ({hexColor, name, walkingTime}) => {
    return (
        <div className={style.main}>
            <div className={style.metroColor} style={{backgroundColor: `#${hexColor}`}} />
            <Typography className={style.stationName} variant={'label-12-r'}>
                {name}
            </Typography>
            {walkingTime && (
                <div className={style.walkingTime}>
                    <Icon className={style.human} icon={'dude'} />
                    <Typography variant={'label-12-r'}>{walkingTime}</Typography>
                </div>
            )}
        </div>
    );
};
